/* This file is autogenerated, see readme.md for instructions */
import UsagesSvgIcon from '@bloomreach/banana-theme/icons/usages.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UsagesIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UsagesSvgIcon />
    </Icon>
  );
});

UsagesIcon.displayName = 'UsagesIcon';

export default UsagesIcon;
